import { ReactElement, memo } from 'react';
import cn from 'classnames';
import iconMap from './iconMap';

import styles from './IconWrapper.module.scss';

export interface IconProps {
  classNames?: string;
  fill?: string;
  width?: number;
  height?: number;
  testId?: string;
}

export interface IconWrapperProps extends IconProps {
  icon: string;
}

const IconWrapper = ({
  icon,
  classNames,
  fill = 'var(--color-gray-darker)',
  testId = 'icon-span',
  width,
  height,
}: IconWrapperProps): ReactElement | null => {
  const Icon = (iconMap as Record<string, any>)[icon];

  const rootClasses = cn(styles.iconRoot, classNames);

  return (
    <span className={rootClasses} data-testid={testId}>
      {Icon && (
        <Icon
          fill={fill}
          width={!width && !height ? 16 : width}
          height={!width && !height ? 16 : height}
          data-testid="icon"
        />
      )}
    </span>
  );
};

export default memo(IconWrapper);
